<div class="row">
     <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Categoria'"
          [valueInput]="altraParte.categoriaAltraParte?.label"></div>
     <div labelTextInput class="col-sm-6 bloccodati"
          [typeLabel]="'text'"
          [labelInput]="'Parte (se legale di controparte)'"
          [valueInput]="altraParte.controparte ? (altraParte.controparte.parte.nominativo) : ''">
     </div>  
</div>
<div class="row">
     <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Rinunciatario'"
          [valueInput]="altraParte.ritirato ? 'Sì' : 'No'"></div>
     <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'" [labelInput]="'Data Rinuncia'"
          [valueInput]="altraParte.dataTermine"></div>
</div>
<div class="row">
     <div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'text'" [labelInput]="'Note'"
          [valueInput]="altraParte.note"></div>
</div>